import { useMemo } from 'react';
import { Hub } from '@/api/apis/facilities';
import { useHubsQuery } from '@/queries/hub';
import { useSearchableList } from '@/hooks/useSearchableList';
import { NameByValue } from '@/types';

type UseHubsSearchableListProps = {
  searchBy?: (keyof Hub)[];
};

export const useHubsSearchableList = ({ searchBy = [] }: UseHubsSearchableListProps) => {
  const { data, isLoading } = useHubsQuery();

  const hubsList = useMemo(() => data?.items || [], [data]);

  const { list, setSearchValue } = useSearchableList(hubsList, searchBy);

  const hubsSelectList = useMemo<NameByValue<string>[]>(() => {
    return (
      list.map((item) => ({
        name: item.name,
        value: item.id,
      })) || []
    );
  }, [list]);

  return {
    hubs: hubsList,
    list: hubsSelectList,
    isLoading,
    setSearchValue,
  };
};
